//Parroquias Apure
const munAchaguas = [
  'Urbana',
  'Apurito',
  'El Yagual',
  'Guachara',
  'Mucuritas',
  'Queseras del Medio',
];
const munBiruaca = ['Urbana Biruaca'];
const munMunoz = [
  'Urbana Bruzual',
  'Mantecal',
  'Quintero',
  'Rincón Hondo',
  'San Vicente',
];
const munPaez = [
  'Urbana Guasdualito',
  'Aramendi',
  'El Amparo',
  'San Camilo',
  'Urdaneta',
];
const munPedroCamejo = ['Urbana San Juan De Payara', 'Codazzi', 'Cunaviche'];
const munRomuloGallegos = ['Urbana Elorza', 'La Trinidad'];
const munSanFernando = [
  'Urbana San Fernando',
  'El Recreo',
  'Peñalver',
  'San Rafael De Atamaica',
];

export const esApure = [
  {
    municipio: 'Achaguas',
    parroquias: munAchaguas,
  },
  {
    municipio: 'Biruaca',
    parroquias: munBiruaca,
  },
  {
    municipio: 'Muñoz',
    parroquias: munMunoz,
  },
  {
    municipio: 'Paez',
    parroquias: munPaez,
  },
  {
    municipio: 'Pedro Camejo',
    parroquias: munPedroCamejo,
  },
  {
    municipio: 'Rómulo Gallegos',
    parroquias: munRomuloGallegos,
  },
  {
    municipio: 'San Fernando',
    parroquias: munSanFernando,
  },
];
